import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  isLoading: false,
  successMessage: null,
  errorMessage: null,
  customers: [],
  customersForAdmin: [],
  totalElements: 0,
  createdId: null,
  createdAddressId: null,
});

const { Types, Creators } = createActions({
  customersRequest: null,
  customersRequestSuccess: ['customers'],
  customersRequestFailure: ['errorMessage'],

  getCustomersByDistributorRequest: ['distributorId', 'pageParams'],
  getCustomersByDistributorRequestSuccess: ['customers'],
  getCustomersByDistributorRequestFailure: ['errorMessage'],

  getCustomersForAdminRequest: ['distributorId', 'pageParams'],
  getCustomersForAdminRequestSuccess: ['customersForAdmin', 'totalElements'],
  getCustomersForAdminRequestFailure: ['errorMessage'],

  deleteCustomerRequest: ['customerId', 'distributorId', 'pageParams'],
  deleteCustomerRequestSuccess: ['customersForAdmin', 'successMessage'],
  deleteCustomerRequestFailure: ['errorMessage'],

  createCustomerRequest: ['customerInfos', 'distributorId', 'pageParams'],
  createCustomerRequestSuccess: [
    'createdId',
    'createdAddressId',
    'customersForAdmin',
    'totalElements',
    'successMessage',
  ],
  createCustomerRequestFailure: ['errorMessage'],

  editCustomerRequest: ['customerInfos', 'distributorId', 'pageParams'],
  editCustomerRequestSuccess: ['customersForAdmin', 'successMessage', 'totalElements'],
  editCustomerRequestFailure: ['errorMessage'],
});

export const customersRequest = (state) => state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const customersRequestSuccess = (state, { customers }) => state.merge({ isLoading: false, customers });
export const customersRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const getCustomersByDistributorRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const getCustomersByDistributorRequestSuccess = (state, { customers }) =>
  state.merge({ isLoading: false, customers });
export const getCustomersByDistributorRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const getCustomersForAdminRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const getCustomersForAdminRequestSuccess = (state, { customersForAdmin, totalElements }) =>
  state.merge({ isLoading: false, customersForAdmin, totalElements });
export const getCustomersForAdminRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const deleteCustomerRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const deleteCustomerRequestSuccess = (state, { customersForAdmin, successMessage }) =>
  state.merge({ isLoading: false, customersForAdmin, successMessage });
export const deleteCustomerRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const createCustomerRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const createCustomerRequestSuccess = (
  state,
  { createdId, createdAddressId, customersForAdmin, totalElements, successMessage }
) => state.merge({ isLoading: false, createdId, createdAddressId, customersForAdmin, totalElements, successMessage });
export const createCustomerRequestFailure = (state, { errorMessage }) =>
  state.merge({ isLoading: false, errorMessage });

export const editCustomerRequest = (state) =>
  state.merge({ isLoading: true, errorMessage: null, successMessage: null });
export const editCustomerRequestSuccess = (state, { customersForAdmin, successMessage, totalElements }) =>
  state.merge({ isLoading: false, customersForAdmin, successMessage, totalElements });
export const editCustomerRequestFailure = (state, { errorMessage }) => state.merge({ isLoading: false, errorMessage });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CUSTOMERS_REQUEST]: customersRequest,
  [Types.CUSTOMERS_REQUEST_SUCCESS]: customersRequestSuccess,
  [Types.CUSTOMERS_REQUEST_FAILURE]: customersRequestFailure,

  [Types.GET_CUSTOMERS_BY_DISTRIBUTOR_REQUEST]: getCustomersByDistributorRequest,
  [Types.GET_CUSTOMERS_BY_DISTRIBUTOR_REQUEST_SUCCESS]: getCustomersByDistributorRequestSuccess,
  [Types.GET_CUSTOMERS_BY_DISTRIBUTOR_REQUEST_FAILURE]: getCustomersByDistributorRequestFailure,

  [Types.GET_CUSTOMERS_FOR_ADMIN_REQUEST]: getCustomersForAdminRequest,
  [Types.GET_CUSTOMERS_FOR_ADMIN_REQUEST_SUCCESS]: getCustomersForAdminRequestSuccess,
  [Types.GET_CUSTOMERS_FOR_ADMIN_REQUEST_FAILURE]: getCustomersForAdminRequestFailure,

  [Types.DELETE_CUSTOMER_REQUEST]: deleteCustomerRequest,
  [Types.DELETE_CUSTOMER_REQUEST_SUCCESS]: deleteCustomerRequestSuccess,
  [Types.DELETE_CUSTOMER_REQUEST_FAILURE]: deleteCustomerRequestFailure,

  [Types.CREATE_CUSTOMER_REQUEST]: createCustomerRequest,
  [Types.CREATE_CUSTOMER_REQUEST_SUCCESS]: createCustomerRequestSuccess,
  [Types.CREATE_CUSTOMER_REQUEST_FAILURE]: createCustomerRequestFailure,

  [Types.EDIT_CUSTOMER_REQUEST]: editCustomerRequest,
  [Types.EDIT_CUSTOMER_REQUEST_SUCCESS]: editCustomerRequestSuccess,
  [Types.EDIT_CUSTOMER_REQUEST_FAILURE]: editCustomerRequestFailure,
});

export const CustomersTypes = Types;
export default Creators;
